import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'dateSplitter',
})
export class DateSplitterPipe implements PipeTransform {
    transform(value: any, pattern: string): string {
        if (!value) {
            return;
        }
        const field = pattern.split('@')[0];
        const format = pattern.split('@')[1];
        switch (format) {
            case 'DD/MM/YYYY':
                switch (field) {
                    case 'DD':
                        return value.split('/')[0];
                    case 'MM':
                        return value.split('/')[1];
                    case 'YYYY':
                        return value.split('/')[2];
                    default:
                        return value;
                }
            default:
                return value;
        }
    }
}
